import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {
  customerConstants,
  subEventTabsConstants,
  shutterbDashboardConstants,
} from "../../../../../constants";
import { Images } from "../../../../../assets/images";
import { scrollWindowToTop } from "../../../../../shared";
import GenericTabs from "../../../../../shared/components/Tabs/GenericTabs";
import EventActionCard from "../../../../../shared/components/Events/EventActionCard";
import EventAccordion from "../../../../../shared/components/Accordion/EventAccordion";
import MessageBoardModal from "../../../../../shared/components/MessageBoard/Modal/MessageBoardModal";
import {
  messageBoardActions,
  shutterbDashboardActions,
} from "../../../../../redux/actions";
import EventDetail from "./EventDetail";
import ShutterBGallery from "./ShutterBGallery";
import ReelDetailsModal from "../ReelDetailsModal";
import EventDetailsModal from "../EventDetailsModal";

const eventTabs = [
  {
    label: "Upcoming",
    value: customerConstants.UPCOMING_EVENTS,
    className: "text",
  },
  {
    label: "Completed",
    value: customerConstants.COMPLETED_EVENTS,
    className: "text",
  },
];

const subEventTabs = [
  {
    label: "My Sub Events",
    value: subEventTabsConstants.MY_SUB_EVENTS,
    className: "text",
    width: "126px",
    subEventsKey: "subEvents",
    isOthersEvents: false,
  },
  {
    label: "Other Sub Events",
    value: subEventTabsConstants.OTHER_SUB_EVENTS,
    className: "text",
    width: "142px",
    subEventsKey: "othersSubEvents",
    isOthersEvents: true,
  },
];

const MyEventsTab = (props) => {
  const [...sbMyEvents] = props.sbMyEvents;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [eventDetailId, setEventDetailId] = useState(0);
  const [activeSubTabs, setActiveSubTabs] = useState({});
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [reelModalEventId, setReelModalEventId] = useState(null);
  const [reelModalEventGroupId, setReelModalEventGroupId] = useState(null);
  const [expandedAccordions, setExpandedAccordions] = useState({});
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [expandedSubAccordion, setExpandedSubAccordion] = useState(null);
  const [isSubEventGalleryView, SetIsSubEventGalleryView] = useState(false);
  const [isEventDetailModalOpen, setIsEventDetailModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(customerConstants.UPCOMING_EVENTS);
  const [isRequestMessageModalOpen, setIsRequestMessageModalOpen] =
    useState(false);

  const handleGalleryClick = (eventId, flag) => {
    if (flag) {
      SetIsSubEventGalleryView(true);
    }
    setSelectedEventId(eventId);
    const dataToSend = {
      eventId: eventId,
      sbUserId: flag ? 0 : props.sbUserId,
    };
    props.getGalleryData(dataToSend);
    scrollWindowToTop();
  };

  const handleCheckStatus = (eventId, status, goToPreviousPage) => {
    let decision = true;
    if (status === shutterbDashboardConstants.CHECK_OUT) {
      decision = window.confirm(
        "Have you finished uploading all content to the gallery? Please hit OK to continue to checkout or cancel to go back and finish uploading to the gallery."
      );
    }
    if (decision) {
      let dataObj = {
        id: eventId,
        sbUserId: props.sbUserId,
        checkedStatus: status,
      };
      props.updateSbMyEventsStatus(
        eventId,
        dataObj,
        props.sbUserId,
        goToPreviousPage
      );
    }
  };

  useEffect(() => {
    props.resetSbMyEvents();
    fetchEvents();
    // eslint-disable-next-line
  }, [activeTab]);

  const fetchEvents = async () => {
    await props.getSbMyEvents(props.sbUserId, activeTab);
  };

  const handleEvents = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setSelectedEventId(null);
    }
  };

  const handleCloseModal = () => {
    setIsMessageModalOpen(false);
    setIsRequestMessageModalOpen(false);
  };

  const handleMessageBoard = (eventId, hostName) => {
    setIsRequestMessageModalOpen(true);
    props.getMessages(eventId, props.sbUserId);
    props.getSBById(eventId, props.sbUserId);
    props.bulkUpdateMessageStatus(
      eventId,
      props.sbUserId,
      props.authentication.userId,
      props.authentication.userType
    );
    props.setFormState({
      ...props.formState,
      eventId: eventId,
      sbUserId: props.sbUserId,
      senderId: props.sbUserId,
      name: hostName,
      sender: shutterbDashboardConstants.SHUTTERB,
    });
  };

  useEffect(() => {
    props.setFormState({
      ...props.formState,
      userId: props.data?.userId,
      receiverId: props.data?.userId,
      email: props.data?.sbUser?.email,
    });
    if (Object.keys(props.data).length > 0 && isRequestMessageModalOpen) {
      setIsMessageModalOpen(true);
    }
    // eslint-disable-next-line
  }, [props.data]);

  const handleTabChange = (tabValue) => {
    setActiveTab(tabValue);
    handleEvents(tabValue);
    closeAllAccordions();
    closeAllSubAccordions();
  };

  const handleSubTabChange = (key, tabValue) => {
    closeAllSubAccordions();
    setActiveSubTabs((prev) => ({
      ...prev,
      [key]: tabValue,
    }));
  };

  const getActiveSubTab = (
    key,
    defaultValue = subEventTabsConstants.MY_SUB_EVENTS
  ) => {
    return activeSubTabs[key] ?? defaultValue;
  };

  const handleSubAccordionChange = (panelId) => (event, isExpanded) => {
    setExpandedSubAccordion(isExpanded ? panelId : null);
  };

  const handleAccordionChange = (index) => (event, isExpanded) => {
    setExpandedAccordions((prev) => ({
      ...prev,
      [index]: isExpanded,
    }));
  };

  const closeAllSubAccordions = () => setExpandedSubAccordion(null);

  const closeAllAccordions = () => {
    setExpandedAccordions({});
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setReelModalEventId(null);
    setReelModalEventGroupId(null);
  };

  return (
    <>
      <GenericTabs
        tabs={eventTabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      {/* Render Gallery component when selectedEventId is not null */}
      {selectedEventId ? (
        <ShutterBGallery
          eventId={selectedEventId}
          eventDetails={[...sbMyEvents]}
          onCheckStatus={handleCheckStatus}
          setSelectedEventId={setSelectedEventId}
          handleGalleryClick={handleGalleryClick}
          isSubEventGalleryView={isSubEventGalleryView}
        />
      ) : isMessageModalOpen ? (
        <MessageBoardModal
          isMessageModalOpen={isMessageModalOpen}
          handleCloseModal={handleCloseModal}
          currentUser={shutterbDashboardConstants.SHUTTERB}
          currentUserId={props.sbUserId}
          className="message-board-modal"
        />
      ) : (
        <div className="px-2">
          {sbMyEvents.length ? (
            sbMyEvents.map((event, index) => {
              const subTabKey = `${event.eventGroupId}`;
              const currentActiveSubTab = getActiveSubTab(subTabKey);
              const currentTabConfig =
                subEventTabs.find((tab) => tab.value === currentActiveSubTab) ||
                subEventTabs[0];

              const availableSubTabs =
                (event?.othersSubEvents?.length ?? 0) > 0
                  ? subEventTabs
                  : subEventTabs.filter(
                      (tab) =>
                        tab.value !== subEventTabsConstants.OTHER_SUB_EVENTS
                    );

              // Sub Events or Other Sub Events for this accordion
              const currentSubEvents =
                currentActiveSubTab === subEventTabsConstants.MY_SUB_EVENTS
                  ? event.subEvents
                  : event.othersSubEvents || [];

              return (
                <EventAccordion
                  showEventDate
                  key={event.eventGroupId}
                  event={event}
                  isGroup={event.isGroup}
                  eventTitle={event.isGroup ? event.eventGroupName : null}
                  classes="mui-event-accordion"
                  expanded={expandedAccordions[index] || false}
                  onChange={handleAccordionChange(index)}
                >
                  {event.isGroup && currentSubEvents.length > 0 ? (
                    <React.Fragment>
                      <div className="d-flex flex-wrap">
                        <EventActionCard
                          classes="mh-100px"
                          iconSrc={Images.Reel}
                          iconAlt="recap-details-icon"
                          disabledIcon={Images.ReelDisabled}
                          disabledAlt="recap-details-icon-disabled"
                          isDisabled={!event.isReelExist}
                          onClick={() => {
                            setReelModalEventGroupId(event?.eventGroupId);
                            setIsModalOpen((prev) => !prev);
                          }}
                          title="view combined recap details"
                        />
                      </div>
                      {/* Sub Tabs */}
                      <GenericTabs
                        tabs={availableSubTabs}
                        activeTab={currentActiveSubTab}
                        onTabChange={(tabValue) =>
                          handleSubTabChange(subTabKey, tabValue)
                        }
                      />
                      {/* Sub Tabs */}
                      {currentSubEvents.map((subEvent, subIndex) => (
                        <EventAccordion
                          key={subEvent.id}
                          event={subEvent}
                          isGroup={false}
                          showEventDate
                          showExpandedIcon
                          classes="mui-event-accordion mui-sub-event-accordion"
                          summaryLeadingChildren={<span>{subIndex + 1}.</span>}
                          expanded={expandedSubAccordion === subEvent.id}
                          onChange={handleSubAccordionChange(subEvent.id)}
                        >
                          <EventDetail
                            isGroupEvent
                            isOthersEvents={currentTabConfig.isOthersEvents}
                            event={subEvent}
                            setIsModalOpen={setIsModalOpen}
                            setReelModalEventId={setReelModalEventId}
                            setEventDetailId={setEventDetailId}
                            getEventDetailByEventId={
                              props.getEventDetailByEventId
                            }
                            setIsEventDetailModalOpen={
                              setIsEventDetailModalOpen
                            }
                            handleCheckStatus={handleCheckStatus}
                            handleMessageBoard={handleMessageBoard}
                            handleGalleryClick={handleGalleryClick}
                            sbUserId={props.sbUserId}
                            activeTab={activeTab}
                          />
                        </EventAccordion>
                      ))}
                    </React.Fragment>
                  ) : (
                    <EventDetail
                      event={event?.subEvents?.[0]}
                      setIsModalOpen={setIsModalOpen}
                      setReelModalEventId={setReelModalEventId}
                      setEventDetailId={setEventDetailId}
                      getEventDetailByEventId={props.getEventDetailByEventId}
                      setIsEventDetailModalOpen={setIsEventDetailModalOpen}
                      handleCheckStatus={handleCheckStatus}
                      handleMessageBoard={handleMessageBoard}
                      handleGalleryClick={handleGalleryClick}
                      sbUserId={props.sbUserId}
                      activeTab={activeTab}
                    />
                  )}
                </EventAccordion>
              );
            })
          ) : (
            <p className="d-flex justify-content-center">
              you have no events at the moment.
            </p>
          )}
        </div>
      )}

      <ReelDetailsModal
        isModalOpen={isModalOpen}
        handleModalClose={handleModalClose}
        reelModalEventId={reelModalEventId}
        reelModalEventGroupId={reelModalEventGroupId}
        className="reel-detail-con modal-border-color"
      />

      <EventDetailsModal
        isModalOpen={isEventDetailModalOpen}
        handleModalClose={() => setIsEventDetailModalOpen(false)}
        eventDetail={props.eventDetailById}
        eventDetailId={eventDetailId}
        className="reel-detail-con modal-border-color"
      />
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  sbUserId: state.shutterbAuthentication.sbUserId,
  sbMyEvents: state.shutterbDashboard.sbMyEvents,
  eventDetailById: state.shutterbDashboard.eventDetailById,
  formState: state.messageBoard.formState,
  data: state.messageBoard.data,
  authentication: state.authentication,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  resetSbMyEvents: () => dispatch(shutterbDashboardActions.resetSbMyEvents()),
  getSbMyEvents: (id, status) =>
    dispatch(shutterbDashboardActions.sbMyEvents(id, status)),
  getGalleryData: (data) =>
    dispatch(shutterbDashboardActions.getGalleryData(data)),
  updateSbMyEventsStatus: (eventId, dataObj, sbUserId, goToPreviousPage) =>
    dispatch(
      shutterbDashboardActions.updateSbMyEventsStatus(
        eventId,
        dataObj,
        sbUserId,
        goToPreviousPage
      )
    ),
  getEventDetailByEventId: (eventId) =>
    dispatch(shutterbDashboardActions.getEventDetailByEventId(eventId)),
  setFormState: (data) => dispatch(messageBoardActions.setFormState(data)),
  getSBById: (eventId, sbUserId) =>
    dispatch(messageBoardActions.getSBById(eventId, sbUserId)),
  getMessages: (eventId, sbUserId) =>
    dispatch(messageBoardActions.getMessages(eventId, sbUserId)),
  bulkUpdateMessageStatus: (eventId, sbUserId, userId, userType) =>
    dispatch(
      messageBoardActions.bulkUpdateMessageStatus(
        eventId,
        sbUserId,
        userId,
        userType
      )
    ),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MyEventsTab));
